import React from "react";

const YoutubeFrame = ({ embedId }) => {
  return (
    <div className="vidHolder" style={{ width: "70%" }}>
      <div className="frameWrapper" style={{ width: "100%" }}>
        <iframe
          style={{ width: "100%", height: "420px" }}
          src={`https://www.youtube.com/embed/${embedId}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="youtube video"
        />
      </div>
    </div>
  );
};

export default YoutubeFrame;
